/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { ROOT_API_URL } from '../config/config';

class AuthApiService {
  apiBase = ROOT_API_URL;

  validateUserKey = (key: string) => {
    return fetch(`${this.apiBase}/ValidateUserKey`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        key,
      }),
    });
  };
}

export default new AuthApiService();
